import React from 'react';
import Translate from '../../../src/components/Translate/Translate';
import {useQueryClient} from '@tanstack/react-query';
import app from '../../../src/helpers/app';
import {useDispatch, useSelector} from 'react-redux';
import {IReduxRootState} from '../../../src/@interfaces';
import {removeUploadingFile} from '../../../src/_redux/order-product-files/actions';
import usePermissionGranted from '../../../src/hooks/usePermissionGranted';

export default function ControlPanel(props: {
    controllerName: string,
    orderId?: string | number | null,
    onChooseFileClick: React.MouseEventHandler,
    productCode: string,
    disabled?: boolean,
    onRefresh?: () => void,
}) {
    const hashes = useSelector<IReduxRootState, string[]>(
            state => state.orderProductFiles.uploadingFiles[props.productCode] ?? []
    );
    const dispatch = useDispatch();
    const queryClient = useQueryClient();

    const canUploadFiles = usePermissionGranted('orders@can-upload-order-product-files');

    return <div className="d-flex px-2">
        <div>
            <Translate<HTMLButtonElement>
                    tag="button"
                    type="button"
                    className="btn btn-sm btn-outline-success"
                    disabled={!canUploadFiles || props.disabled}
                    onClick={(props.disabled ?? !canUploadFiles) ? undefined : props.onChooseFileClick}
                    message="OrderForm:FilesList.add-file-button-label"
            />
        </div>
        <div className="justify-content-end ms-auto">
            <button
                    type="button"
                    className="btn btn-sm btn-outline-secondary"
                    disabled={props.disabled}
                    onClick={props.disabled ? undefined : (e) => {
                        if (hashes.length) {
                            dispatch(removeUploadingFile(props.productCode, hashes));
                        }

                        if (props.onRefresh) {
                            props.onRefresh();
                        }

                        const key = app('queryKeys')
                                .getDetailsOfRecordQueryKey(props.controllerName, props.orderId);

                        const target = e.currentTarget;
                        target.disabled = true;

                        queryClient.refetchQueries(key).finally(() => {
                            if (target?.disabled === true) {
                                target.disabled = false;
                            }
                        });
                    }}
            >
                <i className="fa fa-refresh"/>
            </button>
        </div>
    </div>;
}
